import { Autocomplete, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import api from "../../api/axios";
import Swal from "sweetalert2";
import "../../assets/css/Organization/CreateOrganization.css";

import {
  FaBuilding,
  FaGlobe,
  FaMapMarkerAlt,
  FaFlag,
  FaMap,
  FaToggleOn,
} from "react-icons/fa";

export default function OrganizationCreateModal({
  onClose,
  refreshOrganizations,
}) {
  const MAX_LENGTH = 70;
  const [form, setForm] = useState({
    name: "",
    website: "",
    country: "",
    state: "",
    status: "Active",
    address: "",
  });

  const [countries, setCountries] = useState([]);
  // const options = countries.map((c) => ({
  //   value: c,
  //   label: c,
  // }));

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  const [states, setStates] = useState([]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    

    const trimmedValue =
      typeof value === "string" ? value.slice(0, MAX_LENGTH) : value;

    setForm((prev) => ({
      ...prev,
      [name]: trimmedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleWebsiteBlur = () => {
    let website = form.website.trim().toLowerCase();

    if (!website) return;

    // Remove protocol if user somehow pasted it
    website = website.replace(/^https?:\/\//i, "");

    // Remove trailing slash
    website = website.replace(/\/$/, "");

    // If user entered only "amazon" → make it amazon.com
    if (!website.includes(".")) {
      website = `${website}.com`;
    }

    setForm((prev) => ({
      ...prev,
      website,
    }));
  };

  const normalizeWebsite = (value) => {
    if (!value) return "";

    let website = value.trim().toLowerCase();

    website = website.replace(/^https?:\/\//i, "");
    website = website.replace(/\/$/, "");

    if (!website.includes(".")) {
      website = `${website}.com`;
    }

    return website;
  };

  const isBlank = (val) => !val || String(val).trim() === "";


  // const isTooLong = (val) =>
  //   val && String(val).trim().length > MAX_LENGTH;


  const validate = () => {
    const newErrors = {};

    if (isBlank(form.name)) {
      newErrors.name = "Organization name is required";
    }

    // const isValidWebsite = (url) => {
    //   if (!url) return true;

    //   try {
    //     new URL(url);
    //     return true;
    //   } catch {
    //     return false;
    //   }
    // };

    if (isBlank(form.country)) {
      newErrors.country = "Country is required";
    }

    const website = normalizeWebsite(form.website);

if (isBlank(website)) {
    newErrors.website = "Website is required";
}

    if (isBlank(form.state)) {
      newErrors.state = "State is required";
    }

    if (isBlank(form.status)) {
      newErrors.status = "Status is required";
    }

    if (isBlank(form.address)) {
      newErrors.address = "Address is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const fetchCountries = async () => {
    try {
      const res = await api.get("/countries/");

      // Sort alphabetically
      const sorted = res.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      setCountries(sorted);
    } catch (err) {
      console.error("Failed to load countries", err);
    }
  };

  const fetchStates = async (countryCode) => {
    try {
      const res = await api.get(`/countries/${countryCode}/states`);

      const sortedStates = res.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      setStates(sortedStates);

    } catch (err) {
      console.error("Failed to load states", err);
      setStates([]);
    }
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setLoading(true);

      const payload = {
        ...form,
        website: normalizeWebsite(form.website),
      };

      await api.post("/organization/create", payload);

      await Swal.fire({
        icon: "success",
        title: "Organization Created",
        timer: 1200,
        showConfirmButton: false,
      });

      refreshOrganizations();
      onClose();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.detail || "Failed to create organization",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);



  return (
    <div className="org-create-modal__overlay" onClick={onClose}>
      <div
        className="org-create-modal__card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="org-create-modal__header">
          <h3 className="org-create-modal__title">Create Organization</h3>
          <button className="org-create-modal__close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <form onSubmit={submit} className="org-create-modal__body">
          <div className="org-create-modal__grid">



            <div className="org-create-modal__group">
              <label>Organization Name</label>

              <div className="org-create-modal__input-wrapper">
                <FaBuilding className="org-create-modal__icon" />

                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  maxLength={MAX_LENGTH}
                  placeholder="e.g. TechCorp Inc."
                  data-testid="organization-name"
                  className={errors.name ? "input-error" : ""}
                />
              </div>

              {errors.name && (
                <small className="error-text">
                  {errors.name}
                </small>
              )}
            </div>


            {/* WEBSITE */}
            <div className="org-create-modal__group">
              <label>Website</label>
              <div className="org-create-modal__input-wrapper">
                <FaGlobe className="org-create-modal__icon" />
                <input
                  name="website"
                  value={form.website}
                  onChange={handleChange}
                  onBlur={handleWebsiteBlur}
                  maxLength={MAX_LENGTH}
                  data-testid="organization-website"
                  placeholder="https://company.com"
                  className={errors.website ? "input-error" : ""}
                />
              </div>
              {errors.website && (
                <small className="error-text">
                  {errors.website}
                </small>
              )}

            </div>



            <div className="org-create-modal__group">
              <label>Country</label>

              <div className="org-create-modal__input-wrapper">
                <FaFlag className="org-create-modal__icon" />

                <Autocomplete

                  options={countries}
                  getOptionLabel={(option) => option.name}
                  value={
                    countries.find((c) => c.name === form.country) || null
                  }
                  onChange={(event, newValue) => {

                    setForm((prev) => ({
                      ...prev,
                      country: newValue?.name || "",
                      state: "",
                    }));

                    setStates([]);

                    setErrors((prev) => ({
                      ...prev,
                      country: "",
                    }));


                    if (newValue?.iso2) {
                      fetchStates(newValue.iso2);
                    }

                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search country..."
                      error={!!errors.country}
                      data-testid="country"
                    />
                  )}
                />
              </div>

              {errors.country && (
                <small className="org-create-modal__error">
                  {errors.country}
                </small>
              )}
            </div>

            {/* STATE */}
            <div className="org-create-modal__group">
              <label>State / Region</label>
              <div className="org-create-modal__input-wrapper">
                <FaMap className="org-create-modal__icon" />
                <Autocomplete

                  options={states}
                  data-testid="state"
                  getOptionLabel={(option) => option.name}

                  value={
                    states.find(
                      (state) => state.name === form.state
                    ) || null
                  }


                  onChange={(event, newValue) => {

                    setForm((prev) => ({
                      ...prev,
                      state: newValue?.name || ""
                    }));

                    setErrors((prev) => ({
                      ...prev,
                      state: ""
                    }));

                  }}


                  disabled={!form.country}


                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={
                        form.country
                          ? "Search state..."
                          : "Select country first"
                      }
                      error={!!errors.state}
                    />
                  )}

                />
              </div>
              {errors.state && (
                <small className="error-text">
                  {errors.state}
                </small>
              )}

            </div>




            <div className="org-create-modal__group">
              <label>Status</label>

              <div className="org-create-modal__input-wrapper">
                <FaToggleOn className="org-create-modal__icon" />

                <Autocomplete
                  className="org-create-modal__autocomplete"
                  options={statusOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    statusOptions.find(
                      (option) => option.value === form.status
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setForm((prev) => ({
                      ...prev,
                      status: newValue?.value || "",
                    }));

                    setErrors((prev) => ({
                      ...prev,
                      status: "",
                    }));
                  }}
                  disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Status"
                      error={!!errors.status}
                    />
                  )}
                />
              </div>

              {errors.status && (
                <small className="org-create-modal__error">
                  {errors.status}
                </small>
              )}
            </div>


            {/* ADDRESS */}
            <div className="org-create-modal__group org-create-modal__full">
              <label>Address</label>
              <div className="org-create-modal__input-wrapper">
                <FaMapMarkerAlt className="org-create-modal__icon" />
                <textarea
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                  placeholder="Street address, city, zip code..."
                  className={errors.address ? "input-error" : ""}
                  maxLength={MAX_LENGTH}
                  data-testid="organization-address"
                />
              </div>
              {errors.address && (
                <small className="error-text">
                  {errors.address}
                </small>
              )}

            </div>

          </div>

          <div className="org-create-modal__actions">
            <button
              type="button"
              className="org-create-modal__btn org-create-modal__btn--secondary"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="org-create-modal__btn org-create-modal__btn--primary"
            >
              {loading ? "Saving..." : "Save Organization"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}